/**
 * DashboardRedirect - Redirects /dashboard based on user role
 * FiadoSA/Admin -> /credit/dashboard
 * UNE-Credito -> /portfolio/dashboard
 */

import { Navigate } from 'react-router-dom';
import { useAudience } from '@/hooks/useAudience';
import { ROUTES } from '@/constants';

export function DashboardRedirect() {
  const { resolvedRole } = useAudience();

  if (resolvedRole === 'BACKOFFICE') {
    return <Navigate to={ROUTES.PIPELINE_MATRIX} replace />;
  }

  return <Navigate to={ROUTES.PORTFOLIO_DASHBOARD} replace />;
}
